import { render } from "./loading-view.vue?vue&type=template&id=fc77da50&scoped=true"
import script from "./loading-view.vue?vue&type=script&lang=js"
export * from "./loading-view.vue?vue&type=script&lang=js"

import "./loading-view.vue?vue&type=style&index=0&id=fc77da50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc77da50"]])

export default __exports__